
import { v4 as uuidv4 } from 'uuid';

export interface AnonymousSession {
  sessionId: string;
  createdAt: string;
  userAgent: string;
}

export const getAnonymousSessionId = (): string => {
  const storageKey = 'treguim_anonymous_session';
  
  try {
    const stored = sessionStorage.getItem(storageKey);
    if (stored) {
      const session: AnonymousSession = JSON.parse(stored);
      return session.sessionId;
    }
  } catch (error) {
    console.warn('Could not retrieve anonymous session from storage:', error);
  }
  
  // Create new session
  const sessionId = uuidv4();
  const session: AnonymousSession = {
    sessionId,
    createdAt: new Date().toISOString(),
    userAgent: navigator.userAgent || 'unknown'
  };
  
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(session));
  } catch (error) {
    console.warn('Could not store anonymous session:', error);
  }
  
  return sessionId;
};

export const clearAnonymousSession = (): void => {
  try {
    sessionStorage.removeItem('treguim_anonymous_session');
  } catch (error) {
    console.warn('Could not clear anonymous session:', error);
  }
};

export const getClientInfo = () => {
  return {
    userAgent: navigator.userAgent || 'unknown',
    // Simple IP detection fallback - in production you might want to use a service
    language: navigator.language || 'unknown',
    platform: navigator.platform || 'unknown'
  };
};
